import AutomaticRepliesViewState from 'mini-options-store/lib/store/schema/AutomaticRepliesViewState';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import setReplyOnlyToMyOrganizationText from '../../actions/automaticReplies/setReplyOnlyToMyOrganizationText';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

const setReplyOnlyToMyOrganizationTextMutator = mutator(
    setReplyOnlyToMyOrganizationText,
    actionMessage => {
        const store = getOptionsStore();
        if (store && store.activeViewState) {
            const viewState = store.activeViewState as AutomaticRepliesViewState;
            const { replyOnlyToMyOrganizationText } = actionMessage;
            if (
                replyOnlyToMyOrganizationText != null &&
                replyOnlyToMyOrganizationText != undefined &&
                replyOnlyToMyOrganizationText !== viewState.replyOnlyToMyOrganizationText
            ) {
                viewState.replyOnlyToMyOrganizationText = replyOnlyToMyOrganizationText;
                // Mobile app sets message in both internal and external for consumers.
                if (isConsumer()) {
                    viewState.replyToExternalSendersText = replyOnlyToMyOrganizationText;
                }
                viewState.isDirty = true;
            }
        }
    }
);

export default setReplyOnlyToMyOrganizationTextMutator;
